module.exports = __webpack_public_path__ + "img/banner05_info2.1f3dbc88.svg";